import { IndustryConfig } from '../../../types'

export const automotiveServicesConfig: IndustryConfig = {
  id: 'automotive-services',
  name: 'Automotive Services',
  icon: '🚗',
  description: 'Body shops, mechanical repair, and automotive service providers',
  
  businessTypes: [
    {
      id: 'body-shop',
      name: 'Body Shop',
      description: 'Collision repair and bodywork services'
    },
    {
      id: 'mechanical-repair',
      name: 'Mechanical Repair',
      description: 'Engine, transmission, and general automotive repair'
    },
    {
      id: 'full-service',
      name: 'Full Service',
      description: 'Complete automotive repair and maintenance'
    },
    {
      id: 'specialty',
      name: 'Specialty (Paint/Restoration)',
      description: 'Specialized paint work, restoration, and custom services'
    }
  ],
  
  revenueStreamTypes: [
    {
      id: 'insurance-work',
      name: 'Insurance Work',
      description: 'Work paid through insurance claims and DRP agreements',
      intelligenceValue: "We'll monitor insurance industry rate changes, policy shifts, and preferred provider network changes 60-90 days before they affect you."
    },
    {
      id: 'cash-direct-pay',
      name: 'Cash/Direct Pay',
      description: 'Direct customer payments and cash transactions',
      intelligenceValue: "We'll monitor local economic indicators, consumer spending patterns, and competitive pricing in your area."
    },
    {
      id: 'fleet-commercial',
      name: 'Fleet/Commercial',
      description: 'Business fleet and commercial vehicle services',
      intelligenceValue: "We'll track commercial vehicle trends, fleet management changes, and B2B service pricing."
    }
  ],
  
  supplierCategories: [
    {
      id: 'paint-suppliers',
      name: 'Paint Suppliers',
      suppliers: ['PPG Industries', 'Sherwin-Williams', 'Axalta', 'BASF', 'Other'],
      spendRanges: ['Under $2K', '$2K-$5K', '$5K-$10K', 'Over $10K']
    },
    {
      id: 'parts-sourcing',
      name: 'Parts Sourcing',
      suppliers: ['Local dealerships', 'LKQ/Recycled parts', 'Aftermarket suppliers', 'Direct from manufacturers'],
      spendRanges: ['Under $5K', '$5K-$15K', '$15K-$30K', 'Over $30K']
    },
    {
      id: 'tools-equipment',
      name: 'Tools & Equipment',
      suppliers: ['Snap-on', 'Mac Tools', 'Matco Tools', 'Harbor Freight', 'Local suppliers'],
      spendRanges: ['Under $1K', '$1K-$3K', '$3K-$8K', 'Over $8K']
    }
  ],
  
  competitiveFactors: [
    'Insurance partnerships',
    'Location/convenience',
    'Price competitive',
    'Quality reputation',
    'Fast turnaround',
    'Specialized equipment',
    'Customer service',
    'Warranty coverage'
  ]
}